<script lang="ts">
    import { KEY_CODE_ESC } from "@/constants";
    import clickOutside from "@ui-utils/actions/clickOutside";
    import { createEventDispatcher, onMount } from "svelte";

    import type { PositionType } from "./positions";
    import {
        BOTTOM_LEFT,
        BOTTOM_POSITIONS,
        LEFT_POSITIONS,
        RIGHT_POSITIONS,
        TOP_POSITIONS,
    } from "./positions";

    export let position: PositionType = BOTTOM_LEFT;
    export let opened = false;
    export let autoClose = false;
    export let disabled = false;

    let wrapper: HTMLElement | null = null;

    const dispatch = createEventDispatcher();

    export const close = () => {
        opened = false;
        dispatch("close");
    };
    const open = () => {
        if (disabled) return;
        opened = true;
        dispatch("open");
    };
    const handleToggle = () => {
        if (opened) {
            close();
        } else {
            open();
        }
    };
    const handleKeydown = (e: KeyboardEvent) => {
        if (e.keyCode === KEY_CODE_ESC) {
            close();
        }
    };
    onMount(() => {
        if (wrapper) {
            const activator = wrapper.querySelector("[slot='activator']");
            if (!activator) return;
            activator.addEventListener("click", handleToggle);
            return () => {
                activator.removeEventListener("click", handleToggle);
            };
        }
    });

    const handleInnerClicks = () => {
        if (autoClose) close();
    };
</script>

<div
    use:clickOutside
    on:clickOutside={close}
    bind:this={wrapper}
    on:keydown={handleKeydown}
    class="gw-actions-popover"
>
    <slot name="activator" />
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
        on:click={handleInnerClicks}
        class="gw-actions-popover-wrapper"
        class:gw-actions-popover-wrapper--opened={opened}
        class:position--left={LEFT_POSITIONS.includes(position)}
        class:position--right={RIGHT_POSITIONS.includes(position)}
        class:position--top={TOP_POSITIONS.includes(position)}
        class:position--bottom={BOTTOM_POSITIONS.includes(position)}
    >
        <slot />
    </div>
</div>

<style>
    .gw-actions-popover {
        display: inline-flex;
        position: relative;
        align-items: center;
        justify-content: center;
    }
    .gw-actions-popover-wrapper {
        display: none;
        position: absolute;
        z-index: 2;
        overflow: auto;
        backface-visibility: hidden;
        border-radius: 10px;
        box-shadow: var(--gw-shadow-xl);
        will-change: left right transform;
        contain: content;
        max-width: 300px;
    }
    .gw-actions-popover-wrapper--opened {
        display: block;
    }
    .gw-actions-popover-wrapper.position--left {
        right: 0;
    }
    .gw-actions-popover-wrapper.position--right {
        left: 0;
    }
    .gw-actions-popover-wrapper.position--bottom {
        bottom: -3px;
        transform: translateY(100%);
    }
    .gw-actions-popover-wrapper.position--top {
        top: -3px;
        transform: translateY(-100%);
    }
</style>
